module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pleg14-c84d513bb7991504a1866b5e7c806353.jpg";